export default __webpack_public_path__ + "static/media/bg-dashboard-0.aaa7a5bb.png";